'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('UsuarioObjectService', function() {
  return {
    convertToSend: function(usuario) {
      let propriedadesAttributes;

      if (usuario.propriedades) {
        propriedadesAttributes = usuario.propriedades.map((propriedade) => ({ propriedade_id: propriedade.id }));
      }

      return {
        ...usuario,
        id: usuario.id || null,
        nome_completo: usuario.nomeCompleto,
        ino_funcao_id: usuario.funcao ? usuario.funcao.id : null,
        st_utiliza_mobile: usuario.utilizaMobile ? 'S' : 'N',
        cor: usuario.cor ? usuario.cor.replace('#', '') : null,
        propriedades_attributes: propriedadesAttributes
      };
    },

    convertToObject: function(usuario) {
      return {
        nomeCompleto: usuario.nome_completo,
        utilizaMobile: usuario.utiliza_mobile,
        cor: usuario.cor ? `#${usuario.cor}` : null,
        propriedades: usuario.propriedades || [],
        ...usuario
      };
    }
  };
});
